// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__YB9-b","text":"TermsOfService_text__3Rq7Y","subtitle":"TermsOfService_subtitle__2VYsD"};